import { render } from "./TelecomunicacaoPage.vue?vue&type=template&id=5f670d12&scoped=true"
import script from "./TelecomunicacaoPage.vue?vue&type=script&lang=js"
export * from "./TelecomunicacaoPage.vue?vue&type=script&lang=js"

import "./TelecomunicacaoPage.vue?vue&type=style&index=0&id=5f670d12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f670d12"]])

export default __exports__